import { sidebarActions } from '../helpers/constants';

const initialState = {
  sidebarItem: null
}

const reducer = (state = initialState, action) => {
  
  const { payload, type } = action;

  switch (type) {
    case sidebarActions.CHANGE_SIDEBAR_ITEM:
      return {
        ...state,
        sidebarItem: payload
      }
    default:
      return {
        ...state
      }
  }

}

export { reducer as sidebarReducer };